const i18n_fields = {
  EN: [
    { key: 'index', label: 'No.', sortable: false, thStyle: 'width: 5%' },
    { key: 'name', label: 'File name', sortable: true, thStyle: 'width: 30%'},
    { key: 'description', label: 'Description', sortable: false },
    { key: 'size', label: 'Size', sortable: true, thStyle: 'width: 10%' },
    { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%' },
  ],
  KO: [
    { key: 'index', label: 'No.', sortable: false, thStyle: 'width: 5%' },
    { key: 'name', label: '파일 이름', sortable: true, thStyle: 'width: 30%'},
    { key: 'description', label: '설명', sortable: false },
    { key: 'size', label: '크기', sortable: true, thStyle: 'width: 10%' },
    { key: 'func', label: '더보기', sortable: false, thStyle: 'width: 10%' },
  ],
  JP : [
    { key: 'index', label: 'No.', sortable: false, thStyle: 'width: 5%' },
    { key: 'name', label: 'ファイル名', sortable: true, thStyle: 'width: 30%'},
    { key: 'description', label: '説明', sortable: false },
    { key: 'size', label: 'サイズ', sortable: true, thStyle: 'width: 10%' },
    { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%' },
  ]
}

const _i18n_success = {
  reception : {
    EN: `Report reception`,
    KO: `Report reception`,
    JP: `報告受付`
  }
}

const _i18n_warning = {
  file_size : {
    EN: `Maximum file size`,
    KO: `Maximum file size`,
    JP: `ファイルサイズ 0`
  }
}

const _i18n_error = {
  file_size : {
    EN: `File Size 0`,
    KO: `File Size 0`,
    JP: `ファイルサイズ 0`
  },
  report_failed : {
    EN: `Report`,
    KO: `Report`,
    JP: `レポート`
  }
}

const _i18n_data = {
  i18n_fields,
  _i18n_success,
  _i18n_warning,
  _i18n_error
}

export default _i18n_data